export enum EnvType {
  MAXIM = 'maxim',
  MINI = 'mini',
  POEHALI = 'poehali',
  TAXSEE = 'taxsee',
  TUDA = 'tuda',
  ZARYA = 'zarya',
  BROCAR = 'brocar',
}
